import React from 'react';
import './Extrusiontables.css';


const Extrusiontables = () => {
    return (
        <div className="mold-container">
            <h2 className="heading">Disha Cosmetic Bottle Packaging Hollow Molding Solution</h2>
            <div className="details-grid">
                <div className="left-column">
                    <p><strong>Product</strong> </p>
                    <p><strong>Mold Cavity</strong> </p>
                    <p><strong>Weight</strong></p>
                    <p><strong>Material</strong></p>
                   
                </div>
                <div className="right-column">
                    <p>10-1000mL Cosmetic Bottles</p>
                    <p>2 Cavities</p>
                    <p>3-50g</p>
                    <p>Double-layer PETG</p>
                    
                </div>
            </div>
        </div>
    );
};

export default Extrusiontables;
